export default "__VITE_ASSET__dbec3669__"